import BaseComponent from '../base/baseComponent';
import carouselUtils from '../utilities/carouselUtils';
import get from 'axios';
import analyticsUtils from '../utilities/analyticsUtils';
import Swiper, { A11y, Navigation, Autoplay } from 'swiper';
Swiper.use([Navigation, A11y, Autoplay]);
export default class ProductCarouselEinstein extends BaseComponent {
    constructor(element) {
        super(element);
        this.position = 0;
        this.productIds = [];
        this.trackedProducts = [];
        this.indexMap = new Map();
        this.firstPushToDataLayer = true;
        const recommender = this._el.getAttribute('data-recommender');
        this.recommender = recommender;
        this.visibleSlides = parseInt(this._el.dataset.visibleSlides, 10);
        if (recommender && recommender !== 'false') {
            this.getEinsteinRecommendations();
        }
        else {
            this.animationHandler();
        }
        this.getProductsIds();
        if (window.innerWidth < 1024) {
            this.position = 1;
            this.trackedProducts.push(this.productIds[0]);
        }
        else {
            this.position = 4;
            this.trackedProducts.push(...this.productIds.slice(0, this.position));
        }
        window.addEventListener('scroll', () => {
            if (!this.firstPushToDataLayer) {
                return;
            }
            if (this.isCarouselVisible()) {
                this.prepareDataLayer();
            }
        });
    }
    getEinsteinRecommendations() {
        const einsteinUtils = this.getEinsteinUtils();
        if (einsteinUtils) {
            let parentElement = this._el;
            return this.processRecommendationsTile(parentElement, einsteinUtils);
        }
    }
    processRecommendationsTile(parentElement, einsteinUtils) {
        let recommender = parentElement.dataset.recommender;
        if (recommender) {
            try {
                let params = {
                    userId: einsteinUtils.getCQUserId(),
                    cookieId: einsteinUtils.getCQCookieId(),
                    ccver: '1.01',
                };
                if (parentElement.dataset.recommenderType === 'product-to-product' || parentElement.dataset.recommenderType === 'complete-the-set') {
                    let anchors = [];
                    let productsAnchor = document.querySelectorAll('[data-einstein-pid]');
                    productsAnchor.forEach((productEl) => {
                        anchors.push({
                            id: productEl.dataset.einsteinPid,
                            sku: productEl.dataset.einsteinSecondaryId,
                            type: productEl.dataset.einsteinGroupType,
                            alt_id: productEl.dataset.einsteinGroupId,
                        });
                    });
                    params.anchors = anchors;
                }
                const recommendationsReceived = (einsteinResponse) => {
                    this.fillDomElement(einsteinResponse, parentElement);
                };
                const recommendationsNotReceived = (einsteinResponse) => {
                    // this.removeNavigationCarousel(this.$el.querySelector(this.SELECTORS.list));
                    // this.swiperHandler();
                };
                if (einsteinUtils.getRecs) {
                    einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived, recommendationsNotReceived);
                }
                else {
                    einsteinUtils.widgets = einsteinUtils.widgets || [];
                    einsteinUtils.widgets.push({
                        recommenderName: recommender,
                        parameters: params,
                        callback: recommendationsReceived,
                    });
                }
            }
            catch (error) {
                console.error(error);
            }
        }
    }
    async fillDomElement(einsteinResponse, parentElement) {
        const recommendedProducts = einsteinResponse[parentElement.dataset.recommender].recs;
        const recommenderName = einsteinResponse[parentElement.dataset.recommender].displayMessage.toLowerCase();
        if (recommendedProducts && recommendedProducts.length > 0) {
            let components = [];
            components = recommendedProducts.map((recommendedProduct) => {
                let tileDefinition = {};
                tileDefinition.model = {
                    type: 'product',
                    id: recommendedProduct.id,
                };
                return tileDefinition;
            });
            let url = this._el.dataset.recommenderUrl;
            if (url && url !== null && url !== 'null') {
                const { data } = await get(url, {
                    params: {
                        components: JSON.stringify(components),
                        recommenderName: recommenderName,
                    },
                });
                this.mountRecommenderCarousel(data);
            }
        }
        else {
            //this.removeNavigationCarousel(this.$el.querySelector(this.SELECTORS.list));
        }
    }
    getEinsteinUtils() {
        //@ts-ignore
        let einsteinUtils = window.CQuotient;
        if (einsteinUtils && typeof einsteinUtils.getCQUserId === 'function' && typeof einsteinUtils.getCQCookieId === 'function') {
            return einsteinUtils;
        }
        return null;
    }
    mountRecommenderCarousel(content) {
        let carouselList = this._el.querySelector('.productcarousel-swiper-wrapper');
        carouselList.innerHTML = content;
        // this.removeNavigationCarousel(carouselList);
        this.animationHandler();
        this._el.closest('.productcarouseleinstein').classList.remove('d-none');
        //super.prepareDatalayer();
    }
    animationHandler() {
        if (!this.recommender || this.recommender === 'false') {
            let hideSlidesObj = this._el.dataset.positionHideSlide ? JSON.parse(this._el.dataset.positionHideSlide) : '';
            if (hideSlidesObj && hideSlidesObj !== '' && typeof hideSlidesObj === 'object' && Object.keys(hideSlidesObj).length > 0) {
                let slidesTile = [...this._el.querySelectorAll('.product-tile')];
                if (slidesTile.length > 0) {
                    let hideSlidesKeys = Object.keys(hideSlidesObj).map((key) => parseInt(key, 10));
                    slidesTile.forEach((tile, index) => {
                        if (hideSlidesKeys.includes(index)) {
                            let tileParent = tile.closest('[class*="experience"]');
                            if (tileParent) {
                                tileParent.remove();
                            }
                        }
                    });
                }
            }
        }
        //@ts-ignore
        let gallery = this._el;
        carouselUtils.setSwiperMarkup({
            $el: gallery,
            hasArrows: false,
            hasBullets: false,
        });
        // Now you can use Swiper
        //@ts-ignore
        const swiper = new Swiper(this._el, {
            speed: 400,
            slidesPerView: 1.2,
            watchOverflow: true,
            //centeredSlides: true,
            //slidesOffsetAfter: 217,
            spaceBetween: 20,
            simulateTouch: false,
            navigation: {
                nextEl: '.swiper-button-next-einstein',
                prevEl: '.swiper-button-prev-einstein',
            },
            breakpoints: {
                1024: {
                    //slidesPerView: 'auto',
                    slidesPerView: 4.5,
                    spaceBetween: 24,
                    grabCursor: true,
                    centeredSlides: false,
                    slidesOffsetBefore: 80,
                    slidesOffsetAfter: 24,
                },
            },
        });
        swiper.on('slideChange', (s) => {
            if (swiper.previousIndex < swiper.activeIndex) {
                this.prepareDataLayer();
                this.position++;
            }
            else {
                this.position--;
            }
        });
        if ((!this.recommender || this.recommender === 'false') && this.visibleSlides > 0) {
            this._el.closest('.productcarouseleinstein').classList.remove('d-none');
        }
    }
    getProductsIds() {
        const carouselWrapper = this._el.querySelector('.productcarousel-swiper-wrapper');
        if (carouselWrapper) {
            let index = 0;
            const productTiles = carouselWrapper.querySelectorAll('.product-tile');
            productTiles.forEach((tile) => {
                const productId = tile.getAttribute('data-productid');
                if (productId) {
                    this.productIds.push(productId);
                    this.indexMap.set(productId, index);
                    index++;
                }
            });
        }
    }
    prepareDataLayer() {
        if (this.firstPushToDataLayer) {
            const productToPush = this.productIds.slice(0, this.position);
            this.pushDataLayer(productToPush);
            this.firstPushToDataLayer = false;
        }
        else {
            const productToPush = this.productIds.slice(this.position, this.position + 1);
            if (productToPush.length > 0 && !this.trackedProducts.includes(productToPush[0])) {
                this.trackedProducts.push(productToPush[0]);
                this.pushDataLayer(productToPush);
            }
        }
    }
    isCarouselVisible() {
        const carouselWrapper = this._el.querySelector('.productcarousel-swiper-wrapper');
        if (!carouselWrapper) {
            return false;
        }
        const boundingBox = carouselWrapper.getBoundingClientRect();
        const carouselTop = boundingBox.top;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const carouselHeight = boundingBox.bottom - boundingBox.top;
        const minimumVisiblePosition = viewportHeight - carouselHeight * 0.65;
        return carouselTop <= minimumVisiblePosition;
    }
    pushDataLayer(productsIds) {
        this.findTitleAndIndex();
        let index;
        if (Array.isArray(productsIds) && productsIds.length === 1) {
            index = this.indexMap.get(productsIds[0]);
        }
        let data = {
            forcedPipeline: 'ProductImpressions',
            pids: productsIds,
            item_list_name: this.carouselTitle,
            item_list_id: 'carousel_' + this.carouselIndex,
            product_index: index,
        };
        analyticsUtils.passThroughProcessor(data);
    }
    findTitleAndIndex() {
        let parentElement = this._el.parentElement;
        while (parentElement) {
            if (parentElement.classList.contains('experience-einstein-productCarouselEinstein')) {
                break;
            }
            parentElement = parentElement.parentElement;
        }
        if (parentElement) {
            const headerDiv = parentElement.querySelector('.productcarouseleinstein-header');
            if (headerDiv) {
                const titleElement = headerDiv.querySelector('.title');
                if (titleElement) {
                    this.carouselTitle = titleElement.textContent.trim();
                }
            }
        }
        const titleElements = document.querySelectorAll('.productcarouseleinstein-header .title');
        this.carouselIndex = -1;
        titleElements.forEach((titleElement, i) => {
            const titleText = titleElement.textContent.trim();
            if (titleText === this.carouselTitle) {
                this.carouselIndex = i + 1;
            }
        });
    }
}
